<template>
  <div class="choose-subscription-plan is-direction-row" :class="[`theme-${theme}`, { 'is-disabled': disabled }]">

    <div class="choose-subscription-column__choose">

      <nuttrema-form-alert
         v-if="InstanceSubscriptionOptions.saveError"
         class="is-extra-mb-100"
        :error="InstanceSubscriptionOptions.saveError">
      </nuttrema-form-alert>

      <div class="choose-subscription-plan__col">

        <nuttrema-option-slider-group
           v-model="selected.plan.id"
          :title="$t('label.subscription_plan_top_level_title')"
          :disclaimer="$t('label.subscription_plan_top_level_disclaimer')"
          :disabled="disabled"
          @input="handlePlanChanged">
          <nuttrema-option-slider-item
             v-for="plan in _get(InstanceSubscriptionOptions, 'data.SubscriptionPlans', [])"
            :key="plan.id"
            :value="plan.id"
            :option="plan"
            :selectedCurrencyID="selected.currency_id"
            :selectedCurrencyCode="selectedCurrencyCode"
            :disabled="disabled"
            :theme="theme">
          </nuttrema-option-slider-item>
        </nuttrema-option-slider-group>
      </div>

      <div v-if="_get(selected, 'plan.Children', []).length > 0" class="choose-subscription-plan__col">
        <nuttrema-option-slider-group
           v-model="selected.plan.group.id"
          :theme="theme"
          :title="$t('label.select_your_main_activity')"
          @input="handlePlanGroupChanged">
          <nuttrema-option-slider-item
             v-for="group in _get(selected, 'plan.Children', [])"
            :theme="theme"
            :key="group.id"
            :value="group.id"
            :option="group">
            <p>{{ _get(group, 'name') }}</p>
          </nuttrema-option-slider-item>
        </nuttrema-option-slider-group>
      </div>

      <div class="choose-subscription-plan__col">
        <div class="choose-subscription-plan__features">
          <div class="features__title">
            <div class="features__title--text">{{ $t('label.payment_option') }}</div>
          </div>
          <div class="features__wrap">
            <subscription-option :theme="theme">
              <span slot="title">{{ $t('label.currency') }}</span>
              <nuttrema-radiocheck-group
                 v-model="selected.currency_id"
                 mode="radio"
                :theme="theme"
                :required="true">
                <nuttrema-radiocheck-button
                   v-for="currency in _get(InstanceSubscriptionOptions, 'data.Currencies', [])"
                  :label="currency.id"
                  :key="currency.id">
                {{ currency.symbol }} ({{ currency.name }})
                </nuttrema-radiocheck-button>
              </nuttrema-radiocheck-group>
            </subscription-option>

            <subscription-option :theme="theme">
              <span slot="title">{{ $t('label.payment_plan') }}</span>
              <nuttrema-radiocheck-group
                 v-model="selected.payment_plan_id"
                 mode="radio"
                :theme="theme"
                :required="true">
                <nuttrema-radiocheck-button
                   v-for="paymentPlan in _get(InstanceSubscriptionOptions, 'data.PaymentPlans', [])"
                  :label="paymentPlan.id"
                  :key="paymentPlan.id">
                {{ paymentPlan.name }}
                </nuttrema-radiocheck-button>
              </nuttrema-radiocheck-group>
            </subscription-option>
          </div>
        </div>
      </div>

      <div class="choose-subscription-plan__col">
        <div class="choose-subscription-plan__features"
          :class="{ 'is-show-less': !showAllFeatures && !customize }">
          <div class="features__title" :class="{ 'is-without-bottom-margin': !_isEmpty(_get(selected, 'plan.group.SubscriptionFeatures.ExtendedFeatures', [])) }">
            <div class="features__title--text">{{ $t('label.features') }}</div>
            <div class="features__title--customize" v-if="!_isEmpty(_get(selected, 'plan.group.SubscriptionFeatures.ExtendedFeatures', []))">
              <switch-small
                 class="switch-small"
                 v-model="customize"
                 active-color="#ffc107"
                 inactive-color="#b4bccc"
                :active-text="$t('label.customize_plan')">
              </switch-small>
            </div>
          </div>
          <div class="features__wrap" :class="{ 'without-customization': _isEmpty(_get(selected, 'plan.group.SubscriptionFeatures.ExtendedFeatures', [])) }">
            <p class="features__wrap__extend-plan is-first">{{ $t('label.included_in_plan') }}</p>
            <subscription-feature
               v-for="feature in _get(selected, 'plan.group.SubscriptionFeatures.StandardFeatures', [])"
               type="standard"
              :theme="theme"
              :key="feature.id"
              :feature="feature"
              :customize="customize"
              :selectedCurrencyID="selected.currency_id"
              :selectedPaymentPlanID="selected.payment_plan_id"
              @input="setSubscriptionFeature">
            </subscription-feature>

            <template v-if="!_isEmpty(_get(selected, 'plan.group.SubscriptionFeatures.ExtendedFeatures', []))">
              <p class="features__wrap__extend-plan">{{ $t('label.extra_option') }}</p>
              <subscription-feature
                 v-for="feature in _get(selected, 'plan.group.SubscriptionFeatures.ExtendedFeatures', [])"
                 type="extended"
                :theme="theme"
                :key="feature.id"
                :feature="feature"
                :customize="customize"
                :selectedCurrencyID="selected.currency_id"
                @remove="removeSubscriptionFeature"
                @input="setSubscriptionFeature">
              </subscription-feature>
            </template>
          </div>
          <div class="features__more_less" v-if="!customize && _get(selected, 'plan.group.SubscriptionFeatures.StandardFeatures', []).length > 5">
            <a @click="showAllFeatures = !showAllFeatures">
              <span v-if="showAllFeatures">{{ $t('label.less') }}</span>
              <span v-else>{{ $t('label.more') }}</span>
            </a>
          </div>
        </div>
      </div>

    </div>
    <!-- end ~ choose-subscription-column__choose -->

    <div class="choose-subscription-column__summary">
      <div v-sticky class="sticky">
        <subscription-east-summary-select-plan
          :theme="theme"
          :bottomSummary="false"
          :summary="_get(selected, 'plan')"
          :currencyID="_get(selected, 'currency_id')"
          :paymentPlanID="_get(selected, 'payment_plan_id')"
          :processing="_get(InstanceSubscriptionOptions, 'saving')"
          :preconditions="_get(InstanceSubscriptionOptions, 'meta.preconditions')"
          @previousStep="previousStep"
          @nextStep="nextStep">
        </subscription-east-summary-select-plan>
      </div>
    </div>
    <!-- end ~ choose-subscription-column__summary -->


  </div>
</template>

<script>
import Vue from 'vue';
import { find, first, isEmpty, assign, get, cloneDeep, map, each, has } from 'lodash';

import { removeEmpty } from 'utils';
import VueSticky from 'vue-sticky';

import NuttremaFormAlert from 'components/ui/alert/nuttrema-form-alert';

import NuttremaOptionSliderItem from 'components/ui/switch/nuttrema-option-slider-item';
import NuttremaOptionSliderGroup from 'components/ui/switch/nuttrema-option-slider-group';

import NuttremaRadiocheckGroup from 'components/ui/button/nuttrema-radiocheck-group';
import NuttremaRadiocheckButton from 'components/ui/button/nuttrema-radiocheck-button';

import SwitchSmall from 'components/ui/switch/switch-small';

import ChooseSubscriptionPlanAbstract from 'components/ui/subscription/abstract-choose-subscription-plan';
import SubscriptionFeature from 'components/ui/subscription/cmpt-subscription-feature';
import SubscriptionOption from 'components/ui/subscription/cmpt-subscription-option';
import SubscriptionSummary from 'components/ui/subscription/cmpt-subscription-summary';

import SubscriptionEastSummarySelectPlan from 'components/ui/subscription/cmpt-subscription-east-summary-select-plan';

export default {
  name: 'cmpt-choose-subscription-plan',
  mixins: [ChooseSubscriptionPlanAbstract],
  components: {
    SwitchSmall,
    NuttremaFormAlert,
    SubscriptionOption,
    SubscriptionFeature,
    SubscriptionSummary,
    NuttremaRadiocheckGroup,
    NuttremaOptionSliderItem,
    NuttremaRadiocheckButton,
    NuttremaOptionSliderGroup,
    SubscriptionEastSummarySelectPlan,
  },
  directives: {
    sticky: VueSticky,
  },
  props: {
    email: {
      type: String,
      required: false,
      default: null,
    },
    InstanceSubscriptionOptions: {
      type: Object,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      required: false,
      default: 'global',
    },
  },
  data() {
    return {
      customize: false,
      showAllFeatures: false,
      lessFeaturesLimit: 7,
      test: ['test2'],
      selected: {
        currency_id: null,
        payment_plan_id: null,
        plan: {
          id: null,
          group: {
            id: null,
            features: {},
          },
          features: {},
        },
      },
    };
  },
  computed: {
    selectedCurrencyCode() {
      const currencies = get(this.InstanceSubscriptionOptions, 'data.Currencies', []);
      const currency = find(currencies, item => item.id === this.selected.currency_id);
      return get(currency, 'code');
    },
  },
  methods: {
    handlePlanChanged(value) {
      // console.log('handlePlanChanged', value);
      this.findAndSelectPlan(value);
    },
    initialSelected() {
      const currencies = get(this.InstanceSubscriptionOptions, 'data.Currencies', []);

      const selectedCurrency = find(currencies, item => item.selected);
      this.selected.currency_id = get(selectedCurrency, 'id', null);

      const paymentPlans = get(this.InstanceSubscriptionOptions, 'data.PaymentPlans', []);
      const selectedPaymentPlan = find(paymentPlans, item => item.selected);
      this.selected.payment_plan_id = get(selectedPaymentPlan, 'id', null);

      this.findAndSelectPlan();
    },
    findAndSelectPlan(planID) {
      const plans = get(this.InstanceSubscriptionOptions, 'data.SubscriptionPlans', []);
      const plan = planID ? find(plans, item => Number(item.id) === Number(planID)) : find(plans, item => item.selected);

      if (plan) {
        // console.log('plan', plan);
        let found = [];

        if (has(plan, 'Children')) {
          found = find(plan.Children, item => item.selected) || [];
          if (isEmpty(found)) found = first(plan.Children);

          const group = cloneDeep(found);
          assign(this.selected.plan, plan, { group, features: {} });
        } else {
          const group = cloneDeep(plan);
          assign(this.selected.plan, plan, { group, features: {}, Children: [] });
        }
      }
    },
    handlePlanGroupChanged(value) {
      // console.log('handlePlanGroupChanged', value);
      this.findAndSelectPlanGroup(value);
    },
    findAndSelectPlanGroup(planGroupID) {
      const found = find(this.selected.plan.Children, item => Number(item.id) === Number(planGroupID));
      const group = cloneDeep(found);
      assign(this.selected.plan, { group, features: {} });
    },
    setSubscriptionFeature(params) {
      // console.log('setSubscriptionFeature', params);
      Vue.set(this.selected.plan.features, params.code, { values: params.value, feature: params.feature });
    },
    removeSubscriptionFeature(params) {
      // console.log('removeSubscriptionFeature', params);
      Vue.delete(this.selected.plan.features, params.code);
    },
    getPayload() {
      const payload = {
        email: this.email,
        currency_id: get(this.selected, 'currency_id', null),
        payment_plan_id: get(this.selected, 'payment_plan_id', null),
        subscription: {
          master_plan_id: get(this.selected, 'plan.id', null),
          plan_id: get(this.selected, 'plan.group.id', null),
          features: {},
        },
      };

      each(get(this.selected, 'plan.features', []), (feature, key) => {
        const options = map(feature.values, 'id');
        Vue.set(payload.subscription.features, key, options);
      });

      // return payload;
      return removeEmpty(payload);
    },
    nextStep() {
      this.$emit('saveSelection', this.getPayload());
    },
    cancel() {
      this.$emit('cancel');
    },
    previousStep() {
      this.$emit('previousStep');
    },
  },
  created() {
    this.initialSelected();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/subscription/cmpt-choose-subscription-plan.vue